'use client'

/**
 * Dynamically imports and executes a layout function from a different file.
 * @param functionName - The exact string name of the function (e.g., "generateModernSplitPanelLayout")
 * @param resumeData - The raw content payload for the resume
 */
export async function executeLayoutFromFile(functionName: string, functionFile: string, resumeData: any) {
    console.log({ functionName, functionFile });
    try {
        // 1. Dynamically import the file based on its string name.
        // Adjust the relative path to point exactly to your layout folder.
        const fileModule = await import(`./layouts/${functionFile}`);

        // 2. Extract the exported function from the imported module.
        // This assumes your files use named exports matching the filename: 
        // e.g., export function generateModernSplitPanelLayout() { ... }
        const targetFunction = fileModule[functionName];

        // 3. Fallback check: If you used "export default" in those files instead, 
        // you would uncomment the line below:
        // const targetFunction = fileModule.default;

        if (typeof targetFunction !== 'function') {
            throw new Error(`The file "${functionName}.ts" does not export a function named "${functionName}".`);
        }

        // 4. Execute the dynamically loaded function and return the docx object
        return targetFunction(resumeData);

    } catch (error) {
        console.error(`Dynamic import failed for layout function: ${functionName}`, error);
        throw error;
    }
}